import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PaymentDto } from 'src/app/api/invoice/models';
import { PaymentsService } from 'src/app/api/invoice/services';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { PayAmountComponent } from 'src/app/shared/components/pay-amount/pay-amount.component';
import { CONSTANTS } from 'src/app/shared/models/constants';
import { PERMISSION_CONSTANTS } from 'src/app/shared/models/permission-constants';
import { RedirectService } from 'src/app/shared/services/redirect-service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  paymentDetails: any[] = [];
  loader = false;
  invoiceNumber = '';
  constants = CONSTANTS;
  paymentId = '';
  invoiceBalance = 0;
  invoiceId = '';
  invoiceCurrencyCode = '';
  permissionConstants = PERMISSION_CONSTANTS;

  constructor(
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private paymentService: PaymentsService,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    public permissionService: RedirectService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const invoiceNumber = params['invoiceNumber'];
      const invoiceId = params['invoiceId'];
      this.invoiceId = invoiceId;

      const paymentId = params['paymentId'];
      this.paymentId = paymentId;

      this.invoiceNumber = invoiceNumber || '';
      if (invoiceNumber) {
        this.loadPaymentDetails(invoiceNumber);
      } else if (paymentId) {
        this.loadPaymentDetails(paymentId);
      }
    });
  }
  goBack() {
    this.location.back();
  }

  loadInvoiceBalance(invoiceId: string) {
    const params = { id: Number(invoiceId) };
    this.paymentService.getBalanceByInvoiceId(params).subscribe({
      next: response => {
        if (response?.data) {
          this.invoiceBalance = response?.data?.totalBalance || 0;
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  createPayment(row: PaymentDto) {
    if (row) {
      if (this.paymentId) {
        this.router.navigate([], {
          queryParams: {
            advancePaymentId: row?.advancePaymentId,
            paymentId: row?.advancePaymentId,
          },
        });
      } else if (this.invoiceNumber) {
        this.router.navigate([], {
          queryParams: {
            advancePaymentId: row?.advancePaymentId,
            invoiceNumber: row?.invoiceId?.invoiceNumber,
            invoiceId: this.invoiceId,
          },
        });
      }
      const dialogRef = this.dialog.open(PayAmountComponent, {
        disableClose: true,
        data: {
          isUpdate: true,
          remarks: row.remarks,
          amount: row.amountPaid || 0,
          attachmentType:
            row.attachmentType === 'PARTIAL'
              ? { name: 'Partial', value: 'PARTIAL' }
              : { name: 'Full', value: 'FULL' },
          paymentCurrency: row.paymentCurrency?.code,
          invoiceId: row.invoiceId,
          paymentId: row.id,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.operation === CONSTANTS.CREATE_OPERATION) {
          this.invoiceNumber
            ? this.loadPaymentDetails(this.invoiceNumber)
            : this.loadPaymentDetails(this.paymentId);
        }
      });
    }
  }

  onDeleteAction(data: PaymentDto) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      width: '35%',
      minWidth: '320px',
      data: {
        message: `Are you sure you want to delete the payment with ID: ${data.id}?`,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && data.id) {
        this.paymentService.deletePaymentById({ id: data.id }).subscribe({
          next: response => {
            if (response) {
              const message =
                response.message || 'Payment deleted successfully';
              this.toastr.success(message);

              this.invoiceNumber
                ? this.loadPaymentDetails(this.invoiceNumber)
                : this.loadPaymentDetails(this.paymentId);
            }
          },
          error: err => {
            const errorMessage =
              err.error.message ||
              'An error occurred while deleting the payment.';
            this.toastr.error(errorMessage);
          },
        });
      }
    });
  }

  loadPaymentDetails(id: string) {
    this.loader = true;
    const params: any = {
      sort: 'createdAt,desc',
    };

    if (this.paymentId) {
      params.advancePaymentId = parseInt(id);
    } else if (this.invoiceNumber) {
      params.invoiceNumber = parseInt(id);
    }

    this.paymentService.getAllAttachments(params).subscribe({
      next: response => {
        this.invoiceId && this.loadInvoiceBalance(this.invoiceId);
        if (response?.data?.[0]) {
          this.paymentDetails = response.data[0]?.data || [];
          this.loader = false;
          if (this.invoiceId) {
            this.invoiceCurrencyCode =
              this.paymentDetails[0].invoiceId?.quotation?.currency?.code;
          }
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
        this.loader = false;
      },
    });
  }
}
